import {Component} from '@angular/core';
import { Router } from '@angular/router';

/**
 * Szablon widoku mapy
 */
@Component({
  selector: 'app-szablon-mapa',
  templateUrl: './szablon-mapa.component.html',
  styleUrls: ['./szablon-mapa.component.scss']
})
export class SzablonMapaComponent {


constructor(private router: Router) {
  const defaultReuse = this.router.routeReuseStrategy.shouldReuseRoute;

  this.router.routeReuseStrategy.shouldReuseRoute = (future, curr) => {
    if (future.routeConfig?.path === ':uuid' ||
        curr.routeConfig?.path === ':uuid') {
      return false;
    }

    return defaultReuse(future, curr);
  };
}

}
